import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { backendUrl } from './config';
import { getToken, removeToken, setTokens } from './LoginUtils';
import { authMiddleware, loggerMiddleware, RelayNetworkLayer, urlMiddleware } from 'react-relay-network-modern/es';

const network = new RelayNetworkLayer(
	[
		urlMiddleware({
			url: () => `${backendUrl}/graphql-admin`,
		}),
		authMiddleware({
			token: () => getToken(),
			tokenRefreshPromise: req => {
				const refreshToken = getToken('refreshToken');
				const headers = {
					'Content-Type': 'application/json',
				};
				return fetch(`${backendUrl}/refresh-token`, {
					method: 'POST',
					headers,
					body: JSON.stringify({ refreshToken }),
				})
					.then(res => {
						if (res.status === 403) {
							removeToken();
							document.location.href = '/';
						}
						return res.json()
					})
					.then(data => {
						setTokens(data);
						return data.accessToken;
					})
					.catch(err => {
						console.log(err);
					});
			},
			prefix: '',
			header: 'Authorization',
		}),
		loggerMiddleware(),
	],
	{
		disableBatchQuery: true,
		noThrow: true,
	},
);

const source = new RecordSource();
const store = new Store(source);

const modernEnvironment = new Environment({
	network,
	store,
});

export const environment = modernEnvironment;

export default modernEnvironment;



// WEBPACK FOOTER //
// src/lib/RelayUtils.js